
import students from '../api/students'

export const state = {
  students: [],
  student_lessons_pagination_data: {},
  student: '',
  students_class_type: [],
  students_clients: [],
  student_teachers: []
}

export const getters = {
  students: state => state.students,
  student: state => state.student,
  students_class_type: state => state.students_class_type,
  students_clients: state => state.students_clients,
  student_teachers: state => state.student_teachers
}

export const mutations = {
  SET_STUDENTS (state, data) {
    state.students = data
  },
  SET_STUDENT_LESSON_PAGINATION (state, data) {
    state.student_lessons_pagination_data = data
  },
  SET_STUDENTS_CLASS_TYPE (state, data) {
    state.students_class_type = data
  },
  SET_STUDENTS_PER_CLIENT (state, data) {
    state.students_clients = data
  },
  SET_STUDENTS_PER_TEACHER (state, data) {
    state.student_teachers = data
  }
}

export const actions = {
  GET_STUDENTS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      students.get(data).then(response => {
        commit('SET_STUDENTS', response.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_STUDENT_LESSON_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_STUDENT_PER_CLIENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      students.getStudentPerClient(id).then(response => {
        commit('SET_STUDENTS_PER_CLIENT', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  REMOVE_STUDENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      students.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_STUDENTS_CLASS_TYPE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      students.getStudentFromClassType(id).then(response => {
        commit('SET_STUDENTS_CLASS_TYPE', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_STUDENTS_PER_TEACHER ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      students.getStudentsPerTeacher(id).then(response => {
        commit('SET_STUDENTS_PER_TEACHER', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/students.js